import { render } from "./FloatingMenu.vue?vue&type=template&id=9ccd4580&scoped=true"
import script from "./FloatingMenu.vue?vue&type=script&lang=js"
export * from "./FloatingMenu.vue?vue&type=script&lang=js"

import "./FloatingMenu.vue?vue&type=style&index=0&id=9ccd4580&scoped=true&lang=css"
import "./FloatingMenu.vue?vue&type=style&index=1&id=9ccd4580&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ccd4580"]])

export default __exports__